__turbopack_context__.v({
  "tooltip": "tooltip-component-module-scss-module__pNPbZG__tooltip",
  "tooltip__arrow-left": "tooltip-component-module-scss-module__pNPbZG__tooltip__arrow-left",
  "tooltip__arrow-right": "tooltip-component-module-scss-module__pNPbZG__tooltip__arrow-right",
  "tooltip__arrow-top": "tooltip-component-module-scss-module__pNPbZG__tooltip__arrow-top",
  "tooltip__fitContent": "tooltip-component-module-scss-module__pNPbZG__tooltip__fitContent",
});
